<template lang='pug'>
	.privacy-policy
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="Resource Links")
		resourceLinksContent
		v-e24-footer(:build="build")
</template>
<script>
import headerResources from '@/commonSite/header.vue'
import resourceLinksContent from '@/components/resources/content-resource-links.vue'
import imageHeader from '@/img/resourceLinks.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'resource-links',
	components: {
		headerResources,
		resourceLinksContent
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/ResourceLinks.vue